import {ERROR_BACKGROUND, ERROR_COLOR, WARNING_BACKGROUND} from "../../../../themes/themeConfigurator";

const styles = theme => ({
  messageContent: {
    paddingTop: theme.spacing(2),
    '& .no-margin': {
      margin: 0
    }
  },
  normal: {},
  warning: {
    backgroundColor: WARNING_BACKGROUND,
  },
  danger: {
    backgroundColor: ERROR_BACKGROUND,
    '& .fa-exclamation-triangle': {
      color: ERROR_COLOR,
      marginRight: theme.spacing(1)
    }
  },
  dangerButton: {
    color: ERROR_COLOR,
    border: '1px solid',
    borderColor: ERROR_COLOR,
    '&:hover': {
      borderColor: theme.palette.secondary.dark,
      backgroundColor: 'rgba(229, 0, 0, 0.04)',
    },
  },
});

export default styles;
